import { createReducer } from '/@/store/utils';
import * as actions from './actions';

const initial = {
    totalCount: 1,
    currentValue: 0,
};

export default createReducer(initial, {
    [actions.setIncreaseCount]: (state) => {
        return { ...state, currentValue: state.currentValue + 1 };
    },
    [actions.setTotalCount]: (state, action) => {
        return { ...state, totalCount: action.payload };
    },
    [actions.setResetCount]: (state) => {
        return { ...state, currentValue: 0 };
    },
});
